import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/unwar190/web/underwar.org/public_html/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/home/unwar190/web/underwar.org/public_html/layouts/guest.vue").then(m => m.default || m))
}